import { useState } from 'react';
import { toast } from 'sonner';
import { useI18n } from '../i18n/I18nContext';
import { Button } from './ui/button';
import { Share2 } from 'lucide-react';

export const ShareWheel = ({ data, percent, testid = 'share-wheel-btn' }) => {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);

  const renderPng = () => {
    const size = 900;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#0A1A2E';
    ctx.fillRect(0, 0, size, size);
    const cx = size / 2;
    const cy = size / 2 + 30;
    const R = 260;
    const n = data.length || 10;
    for (let ring = 1; ring <= 4; ring++) {
      ctx.beginPath();
      for (let i = 0; i <= n; i++) {
        const a = (Math.PI * 2 * i) / n - Math.PI / 2;
        const r = (R * ring) / 4;
        const x = cx + r * Math.cos(a);
        const y = cy + r * Math.sin(a);
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.strokeStyle = 'rgba(232,197,102,0.25)';
      ctx.lineWidth = 1.5;
      ctx.stroke();
    }
    ctx.textAlign = 'center';
    data.forEach((axis, i) => {
      const a = (Math.PI * 2 * i) / n - Math.PI / 2;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(cx + R * Math.cos(a), cy + R * Math.sin(a));
      ctx.strokeStyle = 'rgba(232,197,102,0.25)';
      ctx.lineWidth = 1.5;
      ctx.stroke();
      const lx = cx + (R + 92) * Math.cos(a);
      const ly = cy + (R + 62) * Math.sin(a);
      ctx.fillStyle = '#F5EDD8';
      ctx.font = 'bold 23px sans-serif';
      ctx.fillText(axis.axis, lx, ly);
      ctx.fillStyle = '#E8C566';
      ctx.font = 'bold 25px sans-serif';
      ctx.fillText(`${axis.value}%`, lx, ly + 30);
    });
    ctx.beginPath();
    data.forEach((axis, i) => {
      const a = (Math.PI * 2 * i) / n - Math.PI / 2;
      const r = (R * Math.min(axis.value, 100)) / 100;
      const x = cx + r * Math.cos(a);
      const y = cy + r * Math.sin(a);
      if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
    });
    ctx.closePath();
    ctx.fillStyle = 'rgba(232,197,102,0.35)';
    ctx.fill();
    ctx.strokeStyle = '#E8C566';
    ctx.lineWidth = 3;
    ctx.stroke();
    ctx.fillStyle = '#E8C566';
    ctx.font = 'bold 40px sans-serif';
    ctx.fillText(t('share.title'), cx, 72);
    ctx.fillStyle = '#5B6B7F';
    ctx.font = '24px sans-serif';
    ctx.fillText("On croit qu'on joue !", cx, size - 40);
    return new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  };

  const share = async () => {
    if (!data?.length || busy) return;
    setBusy(true);
    try {
      const blob = await renderPng();
      const file = new File([blob], 'ma-roue-heritage.png', { type: 'image/png' });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: t('share.title'), text: t('share.text', { percent: percent ?? 0 }) });
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ma-roue-heritage.png';
        a.click();
        URL.revokeObjectURL(url);
        toast.success(t('share.downloaded'));
      }
    } catch (e) {
      if (e?.name !== 'AbortError') toast.error(t('share.error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button onClick={share} disabled={busy || !data?.length} data-testid={testid} variant="outline"
      className="rounded-full border-2 border-or-400/60 text-or-300 font-bold gap-2 bg-transparent hover:bg-or-400/10 mt-4">
      <Share2 className="w-4 h-4" strokeWidth={2.5} /> {t('share.wheel')}
    </Button>
  );
};
